import { atom } from 'jotai';

import defaultValue from './defaultValue';

const favoriteModalStateAtom = atom(defaultValue);

export default favoriteModalStateAtom;
